// extracted by mini-css-extract-plugin
export var bodyTextCard = "StepsMaker-module--bodyTextCard--eb7dd";
export var bulletBox = "StepsMaker-module--bulletBox--434b0";
export var headingTextCard = "StepsMaker-module--headingTextCard--258e4";
export var leftTriangle = "StepsMaker-module--leftTriangle--43c8f";
export var rightTriangle = "StepsMaker-module--rightTriangle--13156";